<template>
  <v-container fluid>
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>Lead Provider & Campaign</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="4"
            sm="6"
          >
            <v-select
              id="api_key"
              v-model="apiKey"
              :items="leadProviders"
              item-title="text"
              item-value="value"
              label="API Key"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="2"
          >
            <v-text-field
              id="ip_address"
              v-model="ipAddress"
              label="IP Address"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            md="4"
            sm="4"
          >
            <v-select
              id="campaign"
              v-model="campaign"
              :items="campaigns"
              item-title="text"
              item-value="value"
              label="Campaign"
              outlined
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    Customer Information-->
    <v-card
      class="my-2"
      elevation="10"
    >
      <v-card-title>Customer Information</v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="first_name"
              v-model="firstName"
              label="First Name"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="last_name"
              v-model="lastName"
              label="Last Name"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <v-text-field
              id="email"
              v-model="email"
              label="Email"
              outlined
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--    End Customer Information-->
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    leadData: {
      type: Object,
      default() {
        return {};
      },
    },
    leadProviders: {
      type: Array,
      default() {
        return [];
      },
    },
    campaigns: {
      type: Array,
      default() {
        return [];
      },
    },
    usStates: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
    };
  },

  computed: {
    apiKey: {
      get() {
        return this.leadData.api_key;
      },
      set(value) {
        this.updateLeadData({ api_key: value });
      },
    },
    ipAddress: {
      get() {
        return this.leadData.ipaddress;
      },
      set(value) {
        this.updateLeadData({ ipaddress: value });
      },
    },
    campaign: {
      get() {
        return this.leadData.campaign;
      },
      set(value) {
        this.updateLeadData({ campaign: value });
      },
    },
    firstName: {
      get() {
        return this.leadData.firstname;
      },
      set(value) {
        this.updateLeadData({ firstname: value });
      },
    },
    lastName: {
      get() {
        return this.leadData.lastname;
      },
      set(value) {
        this.updateLeadData({ lastname: value });
      },
    },
    email: {
      get() {
        return this.leadData.email;
      },
      set(value) {
        this.updateLeadData({ email: value });
      },
    },
    isLineOfCredit() {
      return this.campaigns.some((campaign) => campaign.value === this.leadData.campaign && campaign.text.includes('lineOfCredit'));
    },
  },

  watch: {
    'leadData.campaign': {
      deep: true,
      handler() {
        if (!this.isLineOfCredit) {
          this.updateLeadData({
            initialAmount: this.leadData.requestamount,
          });
        }
      },
    },
  },

  methods: {
    ...mapActions('testSuite', ['updateLeadData']),
  },
};
</script>
